import React, { useState } from "react";
import logo from "../assets/Frame 22 (1).png";
import logored from "../assets/image 107.png";
import { Link, useLocation, useNavigate } from "react-router";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = ({ serviceRef, aboutRef, getStartedRef }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);

  const handleScrollToServices = () => {
    if (serviceRef?.current) {
      const y =
        serviceRef.current.getBoundingClientRect().top +
        window.scrollY -
        50;

      window.scrollTo({ top: y, behavior: "smooth" });
      setMenuOpen(false);
    }
  };

  const handleScrollToAbout = () => {
    if (aboutRef?.current) {
      const y =
        aboutRef.current.getBoundingClientRect().top +
        window.scrollY -
        50;

      window.scrollTo({ top: y, behavior: "smooth" });
      setMenuOpen(false);
    }
  };

  const handleScrollToForm = () => {
    if (getStartedRef?.current) {
      const y =
        getStartedRef.current.getBoundingClientRect().top +
        window.scrollY -
        100;

      window.scrollTo({ top: y, behavior: "smooth" });
      setMenuOpen(false);
    }
  };

  const blogPage = () => {
    navigate("/blogs");
    setMenuOpen(false);
  };

  const handleGoToHome = () => {
    navigate("/");
    setMenuOpen(false);
  };

  return (
    <div className="container navbar-container mt-3">
      <div className="navbar-wrapper">

        <Link to="/" style={{ textDecoration: "none" }}>
          <img
            src={location.pathname === "/" ? logo : logored}
            alt="Patchup Logo"
            className="navbar-logo"
          />
        </Link>

        <div
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <div className={`nav-links ${menuOpen ? "active" : ""}`}>
          {location.pathname === "/" && (
            <>
              <span
                className="font-outfit"
                onClick={handleScrollToServices}
              >
                Services
              </span>

              <span
                className="font-outfit"
                onClick={handleScrollToAbout}
              >
                About Us
              </span>

              <span
                className="font-outfit"
                onClick={blogPage}
              >
                Blogs
              </span>
            </>
          )}

       <button
  onClick={() => {
    location.pathname === "/"
      ? handleScrollToForm()
      : handleGoToHome();
  }}
  className="get-started-btn font-outfit"
>
  {location.pathname === "/" ? "Get Started" : "Home"}
</button>
        </div>

      </div>
    </div>
  );
};

export default Navbar;